import { render, staticRenderFns } from "./OrganizationEventsListContainer.vue?vue&type=template&id=08e42234&scoped=true"
import script from "./OrganizationEventsListContainer.vue?vue&type=script&lang=js"
export * from "./OrganizationEventsListContainer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEventsListContainer.vue?vue&type=style&index=0&id=08e42234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e42234",
  null
  
)

export default component.exports